export const questionTypes = [
    {value:"SS", label: "Single Select"},
    {value:"MS", label: "Multi Select"},
    {value:"OPEN", label: "Text Input"},
    {value:"SSOPEN", label: "Open Single Select"},
    {value:"MSOPEN", label: "Open Multi Select"},
	  {value:"NUMERIC", label: "Number Input"},
	  {value:"GGROUP", label: "Grid"},
    {value:"INTRO", label: "Intro Question"},
  ];

export const GRID_STATEMENT_LABEL = "Grid Statement";
